import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from './Button';
import { checklistGroups, frictionPoints, offer } from '../data/offer';
const outcomes = ['Less searching', 'Less improvisation', 'More structure', 'More confident teaching', 'Better-prepared classes'];
export function FinalCTA() {
  return <section className="bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-55" data-mp="83m8hswxpmyg">
      <div className="mx-auto max-w-4xl" data-id="element-56" data-mp="m46pcjjah8pb">
        <div className="text-center" data-id="element-57" data-mp="m3416jdcpkd3">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-58" data-mp="h654pu67t1bq">
            Your next teaching week
          </p>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-tight text-acad-ink sm:text-5xl" data-id="element-59" data-mp="vtgi81lyiveh">
            Next week you can keep building every class from scratch...
            <br data-id="element-60" data-mp="14uogwksdxy93" />
            <span className="text-acad-gold" data-id="element-61" data-mp="14w7xkchyebbe">
              Or you can walk into the studio with an entire teaching system
              already behind you.
            </span>
          </h2>

          <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-acad-line bg-white p-7 text-left shadow-card" data-id="element-62" data-mp="2c5pwtv1z1c26">
            <ul className="space-y-3" data-id="element-63" data-mp="2h3ztyb79amqf">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-acad-muted" data-id="element-64" data-mp="2m19fhfriye8z">
                  <span className="text-acad-gold" aria-hidden="true" data-id="element-65" data-mp="2v3io2038fxjq">
                    ✦
                  </span>
                  {point}
                </li>)}
            </ul>
          </div>

          <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-66" data-mp="34tlo2k8rubrk">
            {outcomes.map(outcome => <li key={outcome} className="rounded-full border border-acad-gold/45 bg-white px-4 py-1.5 text-sm font-semibold text-acad-ink" data-id="element-67" data-mp="39son9o22lnrm">
                {outcome}
              </li>)}
          </ul>

          <p className="mt-10 text-lg text-acad-muted" data-id="element-68" data-mp="3iqqwurzvdoqi">
            {offer.name} does not replace your experience as an instructor.
          </p>
          <p className="mt-1 font-display text-3xl font-semibold text-acad-gold sm:text-4xl" data-id="element-69" data-mp="1eqbejrwg6ykj">
            It gives that experience a complete system to work with.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-acad-muted" data-id="element-70" data-mp="1npf0r4qwvu39">
            Your teaching knowledge is still yours. Your personality is still
            yours. Your relationship with your students is still yours. Now you
            simply have the structure, lessons, tools, progressions,
            corrections, and resources to support it.
          </p>
        </div>

        <div className="mt-14 rounded-3xl border border-acad-gold/65 bg-white p-7 shadow-soft sm:p-11" data-id="element-71" data-mp="27e7ct11o0yjf">
          <h3 className="text-center font-display text-3xl font-semibold text-acad-ink sm:text-4xl" data-id="element-72" data-mp="h0ynlaiwgig5">
            Everything Included
          </h3>

          <div className="mt-8 space-y-8" data-id="element-73" data-mp="d1prhz0e08hf">
            {checklistGroups.map(group => <div key={group.title} data-id="element-74" data-mp="2whtoxm8gs5t">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-acad-gold" data-id="element-75" data-mp="6xjsxeg5h47s">
                  {group.title}
                </p>
                <div className="mt-3 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-76" data-mp="3parfcyys3m2w">
                  {group.items.map(item => <div key={item} className="flex gap-2.5 text-sm leading-6 text-acad-muted" data-id="element-77" data-mp="3u8sw3d8qf9b7">
                      <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-acad-gold" aria-hidden="true" data-id="element-78" data-mp="3kdivmtxzf9zj" />
                      {item}
                    </div>)}
                </div>
              </div>)}
          </div>

          <div className="mt-10 border-y border-acad-line bg-acad-sand/55 px-6 py-7 text-center font-display text-xl italic leading-8 text-acad-muted sm:text-2xl" data-id="element-79" data-mp="14jh935724xgk">
            “The best class preparation is the preparation you never have to
            rebuild again.”
          </div>

          <div className="mt-9 text-center" data-id="element-80" data-mp="30mdjqhuxboa4">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-acad-gold" data-id="element-81" data-mp="2vou3xdikv3g2">
              The complete 6-in-1 Tap Dance teaching system
            </p>
            <p className="mt-2 font-display text-2xl font-semibold text-acad-ink sm:text-3xl" data-id="element-82" data-mp="2rq4j4zv7mjme">
              {offer.name}
            </p>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-acad-muted" data-id="element-83" data-mp="2hxp1k3ntrx21">
              150 Ready-to-Teach Classes + 6 Complete Volumes + 3 Visual
              Handbooks + 5 Premium Bonuses — created for Tap Dance instructors
              who want to spend less time planning, stop improvising every
              class, and teach with a professional system behind them.
            </p>
            <p className="mt-6 font-display text-4xl font-semibold text-acad-gold sm:text-5xl" data-id="element-84" data-mp="1yyup51bu38p1">
              {offer.todayPrice}
            </p>
            <Button href={offer.checkoutUrl} target="_blank" className="mt-6" data-id="element-85" data-mp="ej6bz3xkzq3g">
              {offer.ctaPrimary}
            </Button>
            <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-acad-muted" data-id="element-86" data-mp="ni05umjj22db">
              <span data-id="element-87" data-mp="shd21xwaglsk">7-Day Money-Back Guarantee</span>
              <span data-id="element-88" data-mp="sg1xvwyxlc0x">Secure Payment</span>
              <span data-id="element-89" data-mp="3rw8ddr4g3jpg">Immediate Access</span>
              <span data-id="element-90" data-mp="3rxjgrptzapg1">Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}